export const path = {
  profile: (userId:string) => `/profil?userId=${userId}`
}